import React from "react";
import { useNavigate } from "react-router-dom";

import { CREATE_COUPON_DEFAULT_VALUES } from "constants/coupons";
import routes from "constants/routes";
import { buildCreateCouponPayload } from "helpers/couponApi";
import { formatApiErrorForDisplay } from "helpers/packageManagementApi";
import { useCreateCoupon } from "store/backend/apiHooks";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import CouponForm from "./CouponForm";

const CreateCoupon = () => {
  const navigate = useNavigate();
  const { openSnackbar } = useSnackbarContext();
  const { mutateAsync, isPending } = useCreateCoupon();

  const handleSubmit = async (values) => {
    try {
      const payload = buildCreateCouponPayload(values);
      const result = await mutateAsync(payload);
      openSnackbar(
        `Coupon "${result?.coupon_code ?? values.code}" created successfully`,
        "success"
      );
      navigate(routes.coupons.list);
    } catch (error) {
      openSnackbar(
        formatApiErrorForDisplay(error, "Failed to create coupon."),
        "error"
      );
    }
  };

  return (
    <CouponForm
      mode="create"
      initialValues={CREATE_COUPON_DEFAULT_VALUES}
      onSubmit={handleSubmit}
      isSubmitting={isPending}
    />
  );
};

export default CreateCoupon;
